import cpt_chart_column_option from '@/components/echarts/attrs/cpt-chart-column-option'
let op = JSON.parse(JSON.stringify(cpt_chart_column_option))

const dataText = JSON.stringify([
    {name:'视频',data:[{name:'一月',value:20},{name:'二月',value:40},{name:'三月',value:50},{name:'四月',value:60},{name:'五月',value:70}]},
    {name:'网站',data:[{name:'一月',value:30},{name:'二月',value:40},{name:'三月',value:45},{name:'四月',value:48},{name:'五月',value:30}]},
    {name:'广告',data:[{name:'一月',value:40},{name:'二月',value:20},{name:'三月',value:10},{name:'四月',value:30},{name:'五月',value:40}]},
])
op.cptDataForm.dataText = dataText
op.attribute.enablePa = '0'
op.attribute.series.barType = null
op.attribute.series.label.position = null
op.attribute.series.label.color = null
op.attribute.dataZoom.show = false
op.attribute.dataZoom.height = 15
op.attribute.cptTableData =  [{ "name": "分组", "value": "", "namekey": "name" },
{ "name": "维度", "value": "", "namekey": "name" },
{ "name": "指标", "value": "", "namekey": "value" }]
export default op